import React, { useState } from "react"
import { useMutation, useQuery } from "urql"

import GraphQLProvider from "../providers/GraphQLProvider"

import { AnimatedModal } from "./shared/Modal"

const QUERY = `
  query PortalAnnouncement {
    proInbox {
      announcements {
        id key title body ctaLabel ctaUrl dismissedAt
      }
    }
  }
`

const DISMISS_MUTATION = `
  mutation DismissPortalAnnouncement($announcementId: ID!) {
    dismissPortalAnnouncement(announcementId: $announcementId) {
      result
      errors
    }
  }
`

const AnnouncementModal = () => {
  const [{ data }] = useQuery({ query: QUERY, requestPolicy: "network-only" })
  const [, dismiss] = useMutation(DISMISS_MUTATION)
  const [visible, setVisible] = useState(true)
  const announcement = data?.proInbox?.announcements?.find((item) => !item.dismissedAt)

  if (!announcement) return null

  const close = () => {
    setVisible(false)
    dismiss({ announcementId: announcement.id })
  }

  const goToAnnouncement = async () => {
    try {
      await dismiss({ announcementId: announcement.id })
    } finally {
      window.location.href = announcement.ctaUrl
    }
  }

  return (
    <AnimatedModal
      visible={visible}
      hideModal={close}
      header={announcement.title}
      showFooter={true}
      hideCancelButton={true}
      actionButtonCopy={announcement.ctaLabel}
      onSave={goToAnnouncement}>
      <p className="text-gray-dark">{announcement.body}</p>
    </AnimatedModal>
  )
}

export default function PortalAnnouncementModal() {
  return (
    <GraphQLProvider>
      <AnnouncementModal />
    </GraphQLProvider>
  )
}
